var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "26px",
    viewBox: "0 0 25 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-859.000000, -2963.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(859.000000, 2963.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,2.53846154 C4,1.13650794 5.13650794,0 6.53846154,0 L13.4700906,0 C13.9427079,0 14.3956789,0.189094392 14.7280183,0.525126478 L20.4886969,6.75589571 C20.8162727,7.08711127 21,7.53415703 21,8 L21,20 C21,22 21,22 19,22 L6,22 C4.5980464,22 4,21.4019536 4,20 L4,14.3846154 L6,14.3846154 L6,6.38461538 L4,6.38461538 L4,2.53846154 Z M13.3737552,2 L6.53846154,2 C6.24107744,2 6,2.24107744 6,2.53846154 L6,20 L19,20 L19,19 L19,8 L13.3737552,2 Z",
    id: "Path",
    fill: "#145685",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Inter-ExtraBold, Inter",
    fontSize: 7,
    fontWeight: 600,
    fill: "#145685"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1,
    y: 13
  }, "PDF")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#F3F3F3",
    strokeWidth: 2,
    fill: "#145685",
    cx: 18,
    cy: 19,
    r: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    points: "16 19 18 21 20 19"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 21,
    x2: 18,
    y2: 16.5,
    id: "Path",
    stroke: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.abd18c84.svg";
export { ForwardRef as ReactComponent };